import React from 'react';
import { Modal, Button } from 'antd';
import styled from 'styled-components';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  icon?: string;
  title: string;
  description: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean;
  loading?: boolean;
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    padding: 24px;
  }

  .ant-modal-body {
    text-align: center;
    padding: 24px 24px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;

  img {
    width: 62px;
    height: 62px;
  }
`;

const Title = styled.h3`
  font-family: Inter;
  font-weight: 700;
  font-size: 20px;
  color: #1F2937;
  margin: 0 0 16px 0;
`;

const Description = styled.div`
  font-family: Inter;
  font-weight: 500;
  font-size: 16px;
  color: #6B7280;
  line-height: 1.6;
  margin: 0 0 32px 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
`;

const CancelButton = styled(Button)`
  min-width: 155px;
  height: 46px;
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #2563EB;
  color: #2563EB;
  
  &:hover {
    border-color: #1D4ED8 !important;
    color: #1D4ED8 !important;
  }
`;

const ConfirmButton = styled(Button)`
  min-width: 155px;
  height: 46px;
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  border-radius: 8px;
  background: #2563EB;
  border-color: #2563EB;
  color: #FFFFFF;
  
  &:hover {
    background: #1D4ED8 !important;
    border-color: #1D4ED8 !important;
    color: #FFFFFF !important;
  }

  &.ant-btn-dangerous {
    background: #DC2626;
    border-color: #DC2626;
    
    &:hover {
      background: #B91C1C !important;
      border-color: #B91C1C !important;
    }
  }
`;

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  icon,
  title,
  description,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  danger = false,
  loading = false,
}) => {
  return (
    <StyledModal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      closable={true}
      width={450}
    >
      {icon && (
        <IconWrapper>
          <img src={icon} alt={title} />
        </IconWrapper>
      )}
      <Title>{title}</Title>
      <Description>{description}</Description>
      <ButtonGroup>
        <CancelButton onClick={onClose} disabled={loading}>
          {cancelText}
        </CancelButton>
        <ConfirmButton
          type="primary"
          danger={danger}
          onClick={onConfirm}
          loading={loading}
        >
          {confirmText}
        </ConfirmButton>
      </ButtonGroup>
    </StyledModal>
  );
};

export default ConfirmModal;

